import React, { useRef } from 'react';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import AdvanceNotice from 'components/Calendar/AdvanceNotice';
import { ReminderSettings } from 'types/calendarSetting';
import s from './s.module.less';
import commonS from '../../s.module.less'

interface Props {
    initValue?: ReminderSettings | null;
    onSave?: () => void;
}

const MinimumTimeAdvance: React.FC<Props> = (props) => {
    const { initValue, onSave } = props;
    const advanceNoticeRef = useRef<{ onUpdate: () => Promise<void> }>(null);


    const handleSave = async () => {
        try {
            await advanceNoticeRef.current?.onUpdate();
            onSave?.();
        } catch (error) {
            console.error('Form save failed:', error);
        }
    };

    const renderEditing = () => {
        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Advance notice</div>
                <AdvanceNotice ref={advanceNoticeRef} value={initValue} />
            </div>
        );
    };

    const renderReview = () => {
        const { minAdvanceBookingHours } = initValue || {};
        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Advance notice</div>
                <div className={commonS.value}>{minAdvanceBookingHours ? `Patients must book at least ${minAdvanceBookingHours} hours in advance` : 'No restriction'}</div>
            </div>
        );
    };

    return (
        <FormCard type='review' title='Minimum time in advance' hasContent={true} onSave={handleSave}>
            {(isEditing) => isEditing ? renderEditing() : renderReview()}
        </FormCard>
    );
};

export default MinimumTimeAdvance;